import React from "react";
import congo from "../../../images/congo.png";
import { useNavigate } from "react-router-dom";

export default function Success() {
  let navigate = useNavigate();
  return (
    <div>
      <section className="login-page congrates-only">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="congrts-middle">
                <p className="Congratulations-p">Congratulations</p>
                <p className="Congratulations-p1">
                  Your password has been reset successfully !
                </p>
                <img src={congo} className="congo-img" alt="" />
                <div className="right-div-12">
                  <button className="Looking-bt" onClick={() => navigate("/")}> Return to log in</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
